<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <b-row>
          <b-col sm="12">
            <iq-card
              class-name="iq-card-block iq-card-stretch iq-card-height"
              body-class=""
            >
              <template v-slot:headerTitle>
                <h4 class="card-title">Doctors</h4>
              </template>
              <template v-slot:body>
                <div>
                  <template>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                    ></v-text-field>
                    <v-data-table
                      :headers="headers"
                      :items="doctors"
                      :search="search"
                    >
                      <template v-slot:item.name="{ item }">
                        {{ item.first_name }} {{ item.last_name }}
                      </template>
                      <template v-slot:item.phone_number="{ item }">
                        {{ item.phone_number || "-" }}
                      </template>
                      <template v-slot:item.email="{ item }">
                        {{ item.email || "-" }}
                      </template>
                      <template v-slot:item.profile_status="{ item }">
                        <b-badge
                          :class="[
                            'border mr-1',
                            item.profile_status === 1
                              ? 'border-success text-success'
                              : item.profile_status === 0
                              ? 'border-warning text-warning'
                              : 'border-danger text-danger',
                          ]"
                          variant="none"
                          >{{
                            DOCTOR_STATUS_MAPPED.get(item.profile_status) ||
                            "Unknown"
                          }}</b-badge
                        >
                      </template>
                      <template v-slot:item.created_at="{ item }">
                        {{ item.created_at && !isNaN(new Date(item.created_at)) ? new Date(item.created_at).toLocaleDateString() : 'Not recorded' }}
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <div class="flex">
                          <b-button
                            variant="outline-primary"
                            class="mr-2"
                            @click="
                              () => navigateToDoctorProfile(item.provider_id)
                            "
                            ><i class="ri-information-line"></i>
                            Details</b-button
                          >
                          <b-button
                            variant="outline-danger"
                            class="mr-2"
                            @click="
                              showModal(item.provider_id, item.first_name)
                            "
                            ><i class="ri-delete-bin-line"></i> Delete</b-button
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </template>
                </div>
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      ref="delete-confirmation"
      size="sm"
      hide-footer
      title="Delete user"
    >
      <p>
        Please confirm if you would like to delete the Doctor
        <b>{{ selectedDoctor.name }}</b>
      </p>
      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="cancelDeletion"
        >Cancel</b-button
      >

      <b-overlay
        :show="deleting"
        rounded="lg"
        opacity="0.2"
        spinner-small
        spinner-variant="danger"
        @hidden="onHidden"
        bg-color="red"
      >
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="confirmDeletion"
          >Confirm</b-button
        >
      </b-overlay>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from '@config/pluginInit'
import IqCard from '@components/xray/cards/iq-card'
import { DOCTOR_STATUS_MAPPED } from '@constants/doctor'
import ProviderService from '@services/provider'
import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading)

export default {
  name: 'Doctors',
  components: { IqCard },

  data () {
    return {
      doctors: [],
      DOCTOR_STATUS_MAPPED,
      selectedDoctor: {
        name: '',
        provider_id: ''
      },
      deleting: false,
      search: '',
      headers: [
        { text: 'First Name', align: 'start', value: 'first_name' },
        { text: 'Last Name', align: 'start', value: 'last_name' },
        { text: 'Phone', value: 'phone_number' },
        { text: 'Email', value: 'email' },
        { text: 'Department', value: 'department' },
        { text: 'Status', value: 'profile_status' },
        { text: 'Registered', value: 'created_at' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    const loader = this.showLoader()
    xray.index()
    ProviderService.get_all_provider_accounts()
      .then((response) => {
        this.doctors = response.data
        loader.hide()
      })
      .catch((error) => {
        console.error('error : ', error)
        loader.hide()
      })
      .finally(() => {
        console.log('execute finally')
        loader.hide()
      })
  },

  methods: {
    navigateToDoctorProfile (id) {
      this.$router.push(`doctors/profile/${id}`)
    },
    showModal (id, name) {
      this.$refs['delete-confirmation'].show()
      this.selectedDoctor.name = name
      this.selectedDoctor.provider_id = id
    },
    cancelDeletion () {
      this.$refs['delete-confirmation'].hide()
      this.selectedDoctor.name = ''
      this.selectedDoctor.provider_id = ''
    },
    showLoader () {
      return this.$loading.show({
        isFullPage: true,
        canCancel: false
      })
    },
    removePatient () {
      const indexToDelete = this.doctors.findIndex(
        (doctor) => doctor.provider_id === this.selectedDoctor.provider_id
      )

      if (indexToDelete !== -1) {
        this.doctors.splice(indexToDelete, 1)
      }
    },
    onHidden () {
      this.$refs.button.focus()
    },
    confirmDeletion () {
      const loader = this.showLoader()
      this.deleting = true
      ProviderService.delete_provider(this.selectedDoctor.provider_id)
        .then(() => {
          this.$refs['delete-confirmation'].hide()
          this.removePatient()
          this.deleting = false
          this.selectedDoctor.name = ''
          this.selectedDoctor.provider_id = ''
          loader.hide()
        })
        .catch((error) => {
          console.error('error deleting provider : ', error)
          loader.hide()
        })
        .finally(() => {
          console.log('executed finally ')
          loader.hide()
        })
    }
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
</style>
